import get from 'lodash/get'

export const isUserDeactivated = (record) => get(record, 'user_account_is_closed', false)
